import { Alert } from 'react-bootstrap';
import styled from 'styled-components';
import { StyledCard } from './Review.styled';

export const StyledReservation = styled.div`
  background-color: #fff;
  flex: 1;
  width: 100%;
  padding-bottom: 8px;

  .card-success {
    background-color: #d1e7dd;
  }

  .reservation-content {
    padding-top: 8px;
  }
`;

export const StyledAlertTitle = styled.div`
  font-size: 1.3rem;
  display: block;
  font-weight: 600;
  margin-bottom: 0.4rem;
`;

export const StyledSuccessAlert = styled(Alert)`
  display: flex;
  flex-direction: row;
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  margin-bottom: 4px;

  .alert-content {
    flex: 1;
  }

  .alert-title {
    font-size: 1.3rem;
    display: block;
    font-weight: 600;
    margin-bottom: 0.4rem;
  }

  .alert-icon {
    font-size: 3rem;
    display: flex;
    align-items: center;
  }
`;

export const StyledReservationCard = styled(StyledCard)`
  padding-left: 1.6rem;
  padding-right: 1.6rem;
  border-radius: 0.75rem;
`;

export const StyledStayTimeGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  gap: 12px;
  margin: 12px 0 16px;

  .stay-time-card {
    background: #faf5f2;
    border-radius: 8px;
    padding: 12px;
    min-width: 0;
  }

  .stay-time-label {
    color: #9a8f88;
    font-size: 0.875rem;
    font-weight: 700;
    line-height: 1.2;
    text-transform: uppercase;
  }

  .stay-time-hour {
    color: #202124;
    font-size: 1.45rem;
    font-weight: 700;
    line-height: 1.1;
    margin-top: 4px;
  }

  .stay-time-date {
    color: #6b7280;
    font-size: 0.95rem;
    line-height: 1.25;
    margin-top: 4px;
  }

  .stay-time-arrow {
    color: #c6b7ad;
    font-size: 1.4rem;
    font-weight: 700;
  }

  @media (max-width: 420px) {
    gap: 8px;

    .stay-time-card {
      padding: 10px;
    }

    .stay-time-hour {
      font-size: 1.25rem;
    }
  }
`;
